// ✅ Youtube API Key를 넣으세요.
export const YOUTUBE_API_KEY = process.env.REACT_APP_YOUTUBE_API_KEY;
